module.exports = __webpack_public_path__ + "static/media/money1.3e732bcb.jpg";